import { useApolloClient } from '@apollo/client/react';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@optools/components/ui/breadcrumb';
import { BTC_BROADCAST_FRAGMENT } from '@optools/services/operator-gateway/btc/fragments';
import { Link, useLocation } from '@tanstack/react-router';
import { capitalize } from 'es-toolkit';
import { Fragment } from 'react';

export interface GameDetailBreadcrumbsProps {
  date: string;
  gamePk: number;
}
export function GameDetailBreadcrumbs({ date, gamePk }: GameDetailBreadcrumbsProps) {
  const client = useApolloClient();
  const breadcrumbs = useLocation({
    select: (location) => location.pathname.split('/').slice(4),
  });

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link from="/" search={{ date }} to="/btc-tools/schedule">
              Schedule
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>{gamePk}</BreadcrumbItem>

        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          const isBroadcastDetail = breadcrumbs.at(-2) === 'broadcasts';

          let title = breadcrumb;

          if (isLast && isBroadcastDetail) {
            const broadcast = client.readFragment({
              fragment: BTC_BROADCAST_FRAGMENT,
              id: client.cache.identify({ __typename: 'Broadcast', mediaId: breadcrumb }),
            });

            if (broadcast) title = broadcast.callSign;
          }

          return (
            <Fragment key={breadcrumb}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>
                    {isBroadcastDetail ? title : capitalize(breadcrumb)}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link
                      from="/"
                      params={{ gamePk }}
                      search={{ date }}
                      to={`/btc-tools/schedule/$gamePk/${breadcrumb}`}>
                      {capitalize(breadcrumb)}
                    </Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
